import { GARMENTS, IMAGES } from "@/lib/pricing";

const Row = ({ label, children, strong = false, testid }) => (
  <div className="flex items-center justify-between gap-4 py-2.5" data-testid={testid}>
    <span className="text-[11px] uppercase tracking-[0.22em] text-[#FDFBF7]/50">{label}</span>
    <span className={`text-sm ${strong ? "text-[#D4AF37]" : "text-[#FDFBF7]/90"}`}>{children}</span>
  </div>
);

export default function OrderSummary({ garment, size, color, quantity, unit, subtotal, shipping, delivery, total }) {
  const g = GARMENTS[garment];
  return (
    <aside
      className="rounded-sm border border-[#D4AF37]/30 bg-[#16211C] p-8 shadow-[0_24px_70px_rgba(22,33,28,0.35)] lg:sticky lg:top-28"
      data-testid="order-summary"
    >
      <p className="ff-script text-2xl text-[#D4AF37]">Your Creation</p>
      <div className="mt-5 overflow-hidden rounded-t-[120px] border border-[#D4AF37]/25">
        <img src={g.img || IMAGES.hero} alt={g.name} className="h-36 w-full object-cover" />
      </div>

      <div className="mt-6 divide-y divide-[#FDFBF7]/8">
        <Row label="Piece" testid="summary-garment">{g.name}</Row>
        <Row label="Size" testid="summary-size">{size}</Row>
        <Row label="Color" testid="summary-color">
          <span className="flex items-center gap-2">
            <span className="inline-block h-3.5 w-3.5 rounded-full border border-[#FDFBF7]/30" style={{ background: color.hex }} />
            {color.name}
          </span>
        </Row>
        <Row label="Quantity" testid="summary-quantity">{quantity}</Row>
        <Row label="Unit price" testid="summary-unit">${unit}</Row>
        <Row label="Subtotal" testid="summary-subtotal">${subtotal}</Row>
        <Row label="Delivery" testid="summary-delivery">
          {delivery === "pickup" ? "Local pickup — Free" : `$${shipping} flat`}
        </Row>
      </div>

      <div className="mt-4 flex items-end justify-between border-t border-dashed border-[#D4AF37]/40 pt-5">
        <span className="text-[11px] uppercase tracking-[0.26em] text-[#FDFBF7]/60">Total</span>
        <span className="ff-serif text-4xl font-light text-[#D4AF37]" data-testid="summary-total">
          ${total}
        </span>
      </div>

      <p className="mt-5 text-xs font-light leading-relaxed text-[#FDFBF7]/50">
        No payment now — Makie will reach out by email to arrange payment and confirm your design
        after you place the order.
      </p>
    </aside>
  );
}
